import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '../state'
import { RootState } from '../..'
import { ConvoService } from '../../../service/ConvoService'
import { IConvo } from '../../../model/convo'
import convoStore from '../convo-store'
import convoUtils from './convo-utils'
import fetchTags from './fetch-tags'

export default async function removeConvoTag(context: BareActionContext<ConvoState, RootState>, payload: { convo: IConvo, tag: string })
{
    convoUtils.convoService.removeTag(payload.convo, payload.tag).then((result: any) => {
        fetchTags(context, payload.convo)
    })

    return
}
